import { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import OneSignal from 'react-onesignal';
import { trackNotificationInteraction } from '../services/analytics';

export const useNotifications = () => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const state = await OneSignal.getNotificationPermission();
        setIsSubscribed(state === 'granted');
      } catch (error) {
        console.error('Error checking notification subscription:', error);
      } finally {
        setLoading(false);
      }
    };

    checkSubscription();
  }, []);

  const subscribe = async () => {
    try {
      setLoading(true);
      const result = await OneSignal.showSlidedownPrompt();
      
      if (result === 'granted') {
        // Set user ID if authenticated
        if (auth.currentUser) {
          await OneSignal.setExternalUserId(auth.currentUser.uid);
        }
        
        // Add tags for segmentation
        await OneSignal.sendTags({
          userType: auth.currentUser ? 'registered' : 'guest',
          subscriptionDate: new Date().toISOString()
        });

        trackNotificationInteraction('push', 'subscribe');
        setIsSubscribed(true);
      }
    } catch (error) {
      console.error('Error subscribing to notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  const unsubscribe = async () => {
    try {
      setLoading(true);
      await OneSignal.setSubscription(false);
      trackNotificationInteraction('push', 'unsubscribe');
      setIsSubscribed(false);
    } catch (error) {
      console.error('Error unsubscribing from notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    isSubscribed,
    loading,
    subscribe,
    unsubscribe
  };
}; 